import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonContent } from '@ionic/react'
import { discountMobx, cartMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import ProductItem from './ProductItem'
import { OrderSwapBuyModal } from '../../modal'
import './index.scss'
import { Icon } from '@cps'

interface IProps {
}

const DiscountOrderSwapBuy: FC<IProps> = ({ }) => {
  const { orderSwapBuyActivity, orderSwapBuyActivityProducts } = discountMobx
  const { orderSwapBuyProductNoToCntMap } = cartMobx.cartResult

  // 判断能否整单换购
  const canOrderSwapBuy = useMemo(() => {
    return orderSwapBuyActivity?.surplusCnt && !orderSwapBuyActivity?.buyAgainFee
  }, [orderSwapBuyActivity])

  // 没有整单换购活动
  if (!orderSwapBuyActivity || !orderSwapBuyActivityProducts.length) {
    return null
  }

  const handleShowActivityDetailModal = () => {
    modalLayer(OrderSwapBuyModal, {})
      .then(() => { })
      .catch(() => { })
  }

  return (
    <div className='discount-order-swap-buy-wrapper' id='DiscountOrderSwapBuyWrapper'>
      <div className='dosb-title'>
        <div className='dosb-tag'><span>{i18n.t('checkout.orderSwapBuy.tag')}</span></div>
        {!orderSwapBuyActivity?.buyAgainFee ? (
          <>
            {orderSwapBuyActivity?.surplusCnt ? i18n.t('checkout.orderSwapBuy.selectCan', { count: orderSwapBuyActivity?.surplusCnt }) : i18n.t('checkout.orderSwapBuy.selectFull')}
          </>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: i18n.t('checkout.orderSwapBuy.selectNeed', { amount: `<span class="price">${format.toPrice(orderSwapBuyActivity?.buyAgainFee)}</span>` }) }}></div>
        )}
      </div>
      <div className='dosb-content'>
        <div className='dosb-product-list'>
          {
            orderSwapBuyActivityProducts.slice(0, 10)?.map((product, index) => {
              const scale = product.scales?.find(scale => !scale.disable)
              return (
                <ProductItem
                  key={index}
                  product={product}
                  count={orderSwapBuyProductNoToCntMap[`${product.no}`]}
                  disabled={!canOrderSwapBuy}
                />
              )
            })
          }
          {
            orderSwapBuyActivityProducts.length > 10 && (
              <div className='dosb-product-item more' data-cypid='discountOrderSwapBuy' onClick={handleShowActivityDetailModal}>
                <div className='more-btn'>
                  <span className='txt'>{i18n.t('result.viewMore')}</span>
                  <Icon name='chevron-right' />
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default observer(DiscountOrderSwapBuy)
